import { toanQuyen } from '../../../../hooks/usePermission';
import { useAuthStore } from '../../../../stores/auth';
import { VAI_TRO_QUAN_TRI_TENANT } from '../../../auth/nghiep-vu/quyen-cong-tenant';
import { useQuyenAudit } from '../../quyen';
import { quyenGhiNhatKy } from '../nghiep-vu/quyen-pham-vi';

/**
 * Quyền của người xem ở cổng tenant trong Nhật ký sử dụng AI — thay `useQuyenKyThuat` của native (`quyen.ts`). Luật ở
 * `nghiep-vu/quyen-pham-vi.ts` (chép `PhamVi.java`). Không đủ quyền thì ẨN (ADR-UI-0005); máy chủ vẫn kiểm lại mọi lượt.
 */

/** Role lớp 1 `TENANT_ADMIN` (đứng ngoài ma trận, ADR-0077) hoặc tài khoản toàn quyền của kho. */
function useLaQuanTri(): boolean {
  const user = useAuthStore((s) => s.user);
  if (!user) return false;
  return toanQuyen(user) || (user.vaiTroLop1?.includes(VAI_TRO_QUAN_TRI_TENANT) ?? false);
}

/** Có hiện liên kết mở trace trong Langfuse không (`audit:ky-thuat:read`). Phần JSON kỹ thuật KHÔNG đứng sau quyền này. */
export function useQuyenKyThuat(): boolean {
  return quyenGhiNhatKy(useQuyenAudit(), useLaQuanTri()).kyThuat;
}
